import { Component, ElementRef, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AssociationsService } from 'app/services/associations.service';
import { AssociationHelper } from 'app/storage/association.storage';
import { catchError, EMPTY, fromEventPattern, lastValueFrom } from 'rxjs';
import { Alert } from 'app/shared/alerts/simple-message/simple-message.component';
import { MeetingFormService } from '../meeting-form.service';
import { SessionStorage } from 'app/storage/session.storage';
import { collectFieldErrors, FieldError, focusAndScrollToField } from 'app/shared/forms/form-validation.util';
@Component({
  selector: 'survey-project-advice',
  templateUrl: './survey-project-advice.component.html',
  styleUrls: ['../meeting-form.component.scss', '../form-steps/form-steps.scss', '../report/report.component.scss', '../form-steps/form-summary/form-summary.scss']
})
export class SurveyProjectAdviceComponent implements OnInit {

  form: FormGroup
  loading: boolean = true

  questions: Question[];
  title: string;

  showAlert: boolean = false
  alertMessage: string = ''
  alertType: Alert = Alert.SUCCESS

  toSubmit: boolean = true
  summary: {[index:string]:any} = {}
  read_only: boolean = false
  opened: boolean = false

  submitted: boolean = false
  fieldErrors: FieldError[] = []

  private readonly REQUIRED_KEYS = [
    "Do you agree with the received advice?",
    "Do you think you will be able to implement all the activities?",
  ]

  constructor(
    private fb: FormBuilder,
    private formService: MeetingFormService,
    private mongoService: AssociationsService,
    private helper: AssociationHelper,
    private router: Router,
    private meetingService: MeetingFormService,
    private auth: SessionStorage,
    private hostRef: ElementRef,
  ) {
    //this.formService.clear() 
    this.form = this.fb.group({
      "Do you agree with the received advice?": ['', Validators.required],
      "Do you think you will be able to implement all the activities?": ['', Validators.required]
    })
    this.formService.setProjectAdviceForm(this.form)

    try{
      let data = require(`assets/meeting-form/survey_project_advice.json`)
      this.questions = data['questions']
      this.title = data['title']
    } catch (e){
      this.questions = []
      this.title = ''
    }
  }

  async ngOnInit() {
    if(!this.auth.isProject()){
      this.read_only = true
      this.opened = true
    }
    if(!this.helper.getSelectedProject() || !this.helper.getSelectedEpe()){
      this.loading = false
      return
    }
    let response = await lastValueFrom(this.mongoService.getProjectAdviceForm(this.helper.getSelectedProject(), this.helper.getSelectedEpe()), {defaultValue: null})
    let form: { [key: string]: any; } | null = response ? response['project_survey_advice'] : null
    if(!form){
      this.loading = false
      return
    }
    this.formService.updateProjectAdviceForm(form)

    this.loading = false

    this.summary = this.meetingService.getProjectAdviceFormSubmit()

    if(!this.auth.isProject()){
      this.read_only = true
    }
    else if(this.summary){
      this.read_only = true
    }
    else{
      this.read_only = false
    }
  }

  isOpenQuestion(question: Question) {
    return typeof question[this.getQuestionKey(question)] === 'string'
  }

  getQuestionKey(question: Question): string{
    return Object.keys(question)[0]
  }

  getQuestion(question: Question): string[] | string{
    return Object.values(question)[0]
  }

  getQuestionDescription(question: Question): string[] | string{
    return question["description"] ? question["description"] : ""
  }

  getKeys(): any[] {
    //console.log(this.summary)
    return Object.keys(this.summary)
  }

  confirm(): void{
    this.submitted = true
    this.fieldErrors = collectFieldErrors(this.form, this.REQUIRED_KEYS.map(key => ({ key, label: key })))
    if(this.fieldErrors.length){
      focusAndScrollToField(this.hostRef.nativeElement, this.fieldErrors[0].key)
      return
    }

    this.mongoService.submitProjectAdviceForm(
      this.helper.getSelectedProject(), 
      this.helper.getSelectedEpe(), 
      this.formService.getProjectAdviceFormSubmit()
      )
      .pipe(
        catchError(
          err => {
            this.addAlert("Advice meeting survey update failed! Please contact the administrator", Alert.ERROR)
            return EMPTY
          }
        )
      )
      .subscribe(
        () => {
          this.addAlert("Advice meeting survey succesfully updated", Alert.SUCCESS)
          this.read_only = true
          this.summary = this.formService.getProjectAdviceFormSubmit()
        }
      )
  }


  addAlert(message: string, type: Alert){
    this.alertMessage = message
    this.alertType = type
    this.showAlert = true
  }

  jumpToField(key: string): void {
    focusAndScrollToField(this.hostRef.nativeElement, key)
  }

}

export interface Question {
  [key:string]: string[] | string
}
